import { Injectable } from "@angular/core"
import { BaseEvent, ArrayStore, BaseSimpleEvent } from 'vasat/dist/src/veflux'
import { Subscription } from "rxjs"

export class KeyEvent extends BaseSimpleEvent<KeyboardEvent>{}


@Injectable()
export class KeyboardService {

  private _isShift:boolean
  private _isCtrl:boolean


  private _keysPressed = new ArrayStore(KeyEvent).setEqualOperator((a,b) => a.keyCode == b.keyCode)
  private keyDown:any
  private keyUp:any
  private _subs:Subscription[] = []
  constructor(){

    this.keyDown = (e:KeyboardEvent) => {
      this._keysPressed.add(e)
   
    }
    this.keyUp = (e:KeyboardEvent) => {
      this._keysPressed.remove(e)
 
    }

    document.addEventListener('keydown', this.keyDown)
    document.addEventListener('keyup', this.keyUp)


    this._subs.push(this._keysPressed.events.subscribe(ev => {
      if(ev.event == 'ADD'){
        if(ev.item.key == 'Shift')                                      this._isShift = true
        else if(ev.item.key == 'Control' || ev.item.key == 'Meta')      this._isCtrl = true
      }
      else if(ev.event == 'REMOVE'){
        if(ev.item.key == 'Shift')                                      this._isShift = false
        else if(ev.item.key == 'Control' || ev.item.key == 'Meta')      this._isCtrl = false
      }
    }))
  }
 
  ngDestroy(){
    document.removeEventListener('keyup', this.keyUp)
    document.removeEventListener('keydown', this.keyDown)
  }


 
  get keysPressed(){
    return this._keysPressed
  } 
  get isShift(){
    return this._isShift
  }
  get isCtrl(){
    return this._isCtrl
  }
}
